import { useState } from 'react'
import "./App.css";
const DeleteAccountPage = () => {
  const [showSuccessToast, setShowSuccessToast] = useState(false);
	const [showDangerToast, setShowDangerToast] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);
	const [appName, setAppName] = useState("");
	const [email, setEmail] = useState("");
	const [isEmailValid, setIsEmailValid] = useState(false);

	const handleDeleteAccount = async () => {
		setShowSpinner(true);
		const sleep = (ms: number) =>
			new Promise((resolve) => setTimeout(resolve, ms));
		await sleep(1000);
		setShowSpinner(false);
		if (appName.toLowerCase() === "payplay") {
			setShowSuccessToast(true);
			setTimeout(() => setShowSuccessToast(false), 3000);
		} else {
			setShowDangerToast(true);
			setTimeout(() => setShowDangerToast(false), 3000);
		}
	};

	const handleAppNameChange = (event: any) => {
		setAppName(event.target.value);
	};

	const handleEmailChange = (event: any) => {
		const newEmail = event.target.value;
		setEmail(newEmail);
		// Email doğrulama işlemi
		const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail);
		setIsEmailValid(isValid);
	};

  return (
  	<div className="login-box">
			{showSpinner && (
				<div className="spinner-container">
					<div className="spinner"></div>
				</div>
			)}
			{showSuccessToast && (
				<div className="toast-message">
					Account has been successfully deleted.
				</div>
			)}
			{showDangerToast && (
				<div className="toast-message-danger">
					No such application found.
				</div>
			)}
			<h2>Delete Account</h2>
			<form>
				<div className="user-box">
					<input
						type="text"
						name=""
						autoCapitalize="none"
						value={appName}
						onChange={handleAppNameChange}
					/>
					<label>App Name</label>
				</div>
				<div className="user-box">
					<input
						type="text"
						name=""
						autoCapitalize="none"
						value={email}
						onChange={handleEmailChange}
					/>
					<label>Email</label>
				</div>
			</form>
			<button
				onClick={handleDeleteAccount}
				className="delete-button"
				style={{ opacity: !isEmailValid || !appName ? 0.2 : 1 }}
				disabled={!isEmailValid || !appName}
			>
				Delete Account
			</button>
		</div>
  )
}

export default DeleteAccountPage
